import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../../store/AppContext';
import cn from '../../../utils/cn';

import styles from './TabsBar.module.scss';
import BackButton from '../../atoms/BackButton/BackButton';

function TabsBar({ items }) {
  const { t } = useTranslation();
  const [{ activeTab }, stateDispatch] = useAppContext();
  const isSmallLaptop = useMediaQuery({ maxWidth: 1220 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  return (
    <div className={styles.bar}>
      {!isSmallLaptop ? <BackButton /> : null}

      <ul className="m-t-30 laptop-m-t-0">
        {items?.map((item, index) => (
          <li key={index}>
            <button
              type="button"
              onClick={() => stateDispatch({ type: 'SET_ACTIVE_TAB', payload: index })}
              className={cn([
                'm-b-20 laptop-m-b-10 w-100 text-left fs-16 fw-500 c-pointer',
                styles.menu_item,
                index === activeTab ? styles.active : '',
              ])}
            >
              {t(item.label)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

TabsBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])).isRequired,
};

export default TabsBar;
